// placeholder card matching the Product card layout while data loads
export default function ProductCardSkeleton() {
  return (
    <div className="bg-canvas w-full h-[362px] rounded-card border border-border shadow-card overflow-hidden animate-pulse">
      <div className="grad w-full h-[200px] flex items-center justify-center">
        <div className="w-[160px] h-[160px] rounded-lg bg-ink/5" />
      </div>
      <div className="px-6 pb-8 flex flex-col gap-y-3">
        <div className="h-3 w-20 bg-ink/10 rounded" />
        <div className="h-4 w-full bg-ink/10 rounded" />
        <div className="h-4 w-2/3 bg-ink/10 rounded" />
        <div className="h-5 w-24 bg-ink/10 rounded mt-2" />
      </div>
    </div>
  );
}
